import { Card, Flex, rem, Text, Title } from "@mantine/core"
import ModelCtaPriceForm from "./form"
import Image from "next/image"




const ModelCtaPrice = () => {
    return (
        <Flex py={{ base: 40, sm: 80 }} w="100%" direction="column" id="model-details">
            <Flex direction="column" className="container" gap={{ base: rem(16), sm: rem(24) }} w="100%" pos="relative">
                <Card
                    radius={16}
                    bg="#FFF4E8"
                    py={{ base: rem(14), sm: rem(24) }}
                    px={{ base: rem(14), sm: rem(24) }}
                >
                    <Flex direction={{ base: "column", sm: "row" }} gap="md" align="center">
                        <Flex
                            direction="column"
                            flex={1}
                            w={{ base: "100%", sm: "50%" }}
                        >
                            <Title
                                fw={700}
                                lh={rem(48)}
                                order={4}
                                fz={{ base: rem(22), sm: rem(30) }}
                            >
                                در مــــورد قـیمت این طــرح سوالـــی داریـــد؟
                            </Title>

                            <Text
                                fw={400}
                                lh={rem(32)}
                                fz={{ base: rem(16), sm: rem(18) }}
                                visibleFrom="sm"
                            >
                                با تکمیل فرم، کارشناسان ما با شما تماس گرفته و به سوالات شما پاسخ می‌دهند.
                            </Text>
                        </Flex>
                        <Flex
                            flex={1}
                            w={{ base: "100%", sm: "50%" }}
                            justify="end"
                        >
                            <ModelCtaPriceForm />
                        </Flex>
                    </Flex>
                </Card>

                <Flex
                    hiddenFrom="sm"
                    pos="absolute"
                    top={{ base: 45, xs: 0 }}
                    left={0}
                    h={80}
                    w={125}
                >
                    <Image
                        src="/images/models/instance-get-price.png"
                        alt="instance price"
                        layout="fill"
                        objectFit="contain"
                    />
                </Flex>
            </Flex>
        </Flex>
    )
}

export default ModelCtaPrice